module.exports = __webpack_public_path__ + "img/Mensajería.419e3497.svg";